import { useEffect, useState } from "react";
import useInstagramGet from "./useInstagramGet";
const useInstagramGetMedia = () => {
  const [error, setError] = useState(null);
  const [datum, setDatum] = useState(null);
  const result = useInstagramGet();
  useEffect(() => {
    if (result.fetch) {
      // console.log("result", result.fetch);
      let allLink = [];
      let allData = Array.from([result.fetch[0]], (m) => {
        // https://graph.facebook.com/{api-version}/{ig-media-id}
        // ?fields={fields}
        // &access_token={access-token}   username  comments_count
        // console.log("result", m.id, result.tokens);
        allLink.push(
          fetch(
            `https://graph.facebook.com/v14.0/${m.id}?access_token=${result.tokens}`,
            {
              method: "GET",
            }
          ).then((r) => r.json())
        );
        return { ...m };
      });
      Promise.all(allLink).then((v) => {
        // console.log("values", v);
        // console.log(allData);
        // console.log(allLink);
      });
    }
  }, [result.fetch]);
  return { error: error, fetch: datum };
};
export default useInstagramGetMedia;
